<template>
  <li
    :class="{
      'frisbuy-gallery-post': true,
      'frisbuy-sale': hasSale,
      'frisbuy-video': post.media.length < 2 && post.media[0].videoUrl,
      'frisbuy-multipost': post.media.length > 1,
      [`frisbuy-provider-${post.frisbuyPost.providerType}`]:
        settings.gallery.showProviderIcon && !isCensored,
    }"
    @click="$emit('click')"
  >
    <div class="frisbuy-post-image">
      <PositionBlockWrapper
        v-if="Object.keys(previewImagePositionStyles).length > 0"
        :x="previewImagePositionStyles.x"
        :y="previewImagePositionStyles.y"
        :scale="previewImagePositionStyles.scale / 100"
      >
        <img
          ref="image"
          :style="{ display: 'block', visibility: 'visible' }"
          :src="imageSource.imageHighRes"
          :data-image-src="imageSource.imageHighRes"
          @load="loadHandler"
          @error="errorHandler"
        />
      </PositionBlockWrapper>
      <div
        v-else
        :class="{ 'frisbuy-invisible': invisible }"
        ref="photo"
        :style="{
          'background-image': `url(${imageSource.imageHighRes}), url(${imageSource.imageLowRes}), ${post.media[0].background}`,
          'background-repeat': 'no-repeat',
        }"
      ></div>

      <img
        ref="image"
        :data-image-src="imageSource.imageHighRes"
        @load="loadHandler"
        @error="errorHandler"
      />
      <div
        :class="{
          [`frisbuy-post-provider-${post.frisbuyPost.providerType}`]:
            !isCensored,
        }"
      ></div>
    </div>

    <div class="frisbuy-post-desc" v-if="postItemSettings.descriptionOnCover">
      <div>
        {{ limitText(post.frisbuyPost.text, postItemSettings.coverTextLimit) }}
      </div>
    </div>

    <div
      v-if="!postItemSettings.hideInfo"
      class="frisbuy-post-cover"
      :style="{ fontSize: `${adaptiveHeight}px`, display: `${coverDispay}` }"
    >
      <span class="frisbuy-post-cover-name">
        {{
          post.instagramPost.authorUser.fio ||
          `@${post.instagramPost.authorUser.username}`
        }}
      </span>

      <div
        class="frisbuy-post-cover-social"
        v-if="post.frisbuyPost.providerType !== 'frisbuy'"
      >
        <div>
          <svg
            width="23"
            height="21"
            viewBox="0 0 23 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.97041 2.08174C4.43099 -0.378843 8.42039 -0.378804 10.8809 2.08183L11.104 2.30488L11.327 2.08183C13.7875 -0.378803 17.7769 -0.378841 20.2375 2.08174C22.698 4.54228 22.698 8.5316 20.2375 10.9921L11.1039 20.1258L1.9704 10.9921C-0.490136 8.5316 -0.490132 4.54228 1.97041 2.08174ZM9.64346 3.31924C7.86634 1.54205 4.985 1.54202 3.20785 3.31917C1.43072 5.0963 1.43072 7.97758 3.20784 9.75471L11.1039 17.6509L19.0001 9.75471C20.7772 7.97758 20.7772 5.0963 19.0001 3.31918C17.2229 1.54202 14.3416 1.54205 12.5645 3.31924L11.7227 4.16105L10.4852 4.16104L9.64346 3.31924Z"
              fill="#ffffff"
            />
          </svg>
          {{ post.instagramPost.likeCountShort }}
        </div>

        <div v-if="!settings.hideCommentCount">
          <svg
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 19.6602L6.10316 16.3762H21.5016V1H1V19.6602Z"
              stroke="#ffffff"
              stroke-width="1.75"
              stroke-linecap="square"
            />
            <path
              d="M6.75234 9.88408C7.42889 9.88408 7.97734 9.33563 7.97734 8.65908C7.97734 7.98253 7.42889 7.43408 6.75234 7.43408C6.07579 7.43408 5.52734 7.98253 5.52734 8.65908C5.52734 9.33563 6.07579 9.88408 6.75234 9.88408Z"
              fill="#ffffff"
            />
            <path
              d="M11.2523 9.88408C11.9289 9.88408 12.4773 9.33563 12.4773 8.65908C12.4773 7.98253 11.9289 7.43408 11.2523 7.43408C10.5758 7.43408 10.0273 7.98253 10.0273 8.65908C10.0273 9.33563 10.5758 9.88408 11.2523 9.88408Z"
              fill="#ffffff"
            />
            <path
              d="M15.7523 9.88408C16.4289 9.88408 16.9773 9.33563 16.9773 8.65908C16.9773 7.98253 16.4289 7.43408 15.7523 7.43408C15.0758 7.43408 14.5273 7.98253 14.5273 8.65908C14.5273 9.33563 15.0758 9.88408 15.7523 9.88408Z"
              fill="#ffffff"
            />
          </svg>

          {{ post.instagramPost.commentCountShort }}
        </div>
      </div>

      <div class="frisbuy-post-cover-logo">
        <svg
          width="180"
          height="180"
          viewBox="0 0 180 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="90" cy="90" r="89" stroke="white" stroke-width="2" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M90.001 46.6504C82.4096 46.6504 76.2556 52.8044 76.2556 60.3958V64.9106H103.746V60.3958C103.746 52.8044 97.5924 46.6504 90.001 46.6504ZM105.746 64.9106V60.3958C105.746 51.6998 98.6969 44.6504 90.001 44.6504C81.305 44.6504 74.2556 51.6998 74.2556 60.3958V64.9106H46.0703L52.5092 128.948H127.492L133.932 64.9106H105.746ZM48.2815 66.9106L54.3182 126.948H125.683L131.72 66.9106H48.2815Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  </li>
</template>

<style scoped lang="scss">
$lassiePrimaryColor: #002354;

* {
  box-sizing: border-box;
}

.frisbuy-gallery-post {
  &:hover {
    .frisbuy-post-image {
      scale: 1.2;
    }
  }

  .frisbuy-post-image {
    transition: scale 0.2s ease-in-out;
  }

  &.frisbuy-multipost .frisbuy-post-image:before {
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi4wNzQxIDBIMFYyNi4wNzQxSDI2LjA3NDFWMFpNMjkuMzE1NCA4LjI5NjI2VjI5LjMxNDhIOC4yOTY4OFYzMi4zMTQ4SDMwLjgxNTRIMzIuMzE1NFYzMC44MTQ4VjguMjk2MjZIMjkuMzE1NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");
    max-width: 16px;
    max-height: 16px;

    margin: 8px;
  }

  .frisbuy-post-cover {
    background-color: #{$lassiePrimaryColor}7d; // opacity 50%

    .frisbuy-post-cover-logo {
      display: block;
      position: absolute;
      inset: 50% 0 0 50%;
      transform: translate(-50%, -50%);

      width: calc(26.684210526315788%);
      height: calc(26.684210526315788%);

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .frisbuy-post-cover-name,
    .frisbuy-post-cover-social {
      position: absolute;
      width: fit-content;

      font-family: Factor A, sans-serif;
      font-size: 16px;
      font-weight: 400;
    }

    .frisbuy-post-cover-name {
      inset: auto auto calc(9.474% + 20px) 5.32%;
    }

    .frisbuy-post-cover-social {
      inset: auto auto 5.32% 5.32%;

      div:first-child {
        margin-right: 12px;
      }

      svg {
        margin-right: 6px;
      }
    }
  }
}
</style>

<script>
import defaultPostItem from "@/gallery/postitem/postitem.vue";

export default {
  extends: defaultPostItem,
};
</script>
